import {Button, Typography} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import {Box, Theme} from '@mui/system';
import React, {FC, useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {localizedDynamic} from '../../../../i18n/i18n';
import {
  disabledButtonColor,
  primaryColor,
  primaryTextColor,
  secondaryTextColor,
  whiteColor,
} from '../../../../styles/color-constants';
import {PrimaryButton} from '../../custom-components/primary-button';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../state/store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    stepperButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
    },
    button: {
      '&:hover': {
        backgroundColor: whiteColor,
        color: primaryTextColor,
      },
    },
    buttonDisabled: {
      backgroundColor: disabledButtonColor,
      borderColor: disabledButtonColor,
      cursor: 'default',
    },
  }),
);
export interface PropsFromParent {
  show: boolean;
  numberOfInputs: number;
  isLastStep: boolean;
  onPressCallback(): void;
}
export const StepperButton: FC<PropsFromParent> = React.memo((props) => {
  const classes = useStyles();
  const [disabledButton, setDisabledButton] = useState(true);
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);
  const {
    getValues,
    formState: {errors},
  } = useFormContext();
  const test = useFormContext();

  useEffect(() => {
    let formState = getValues();
    let numberOfFormsWithValues = Object.keys(formState).filter(
      (fieldName) => formState[fieldName] !== undefined,
    ).length;

    let configuredBefore = selectedProduct?.configurationParams && selectedProduct?.configurationParams?.length > 0;

    if ((props.numberOfInputs <= numberOfFormsWithValues || configuredBefore) && Object.keys(errors).length === 0) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors, getValues, props.numberOfInputs, test.watch(), selectedProduct]);

  return (
    <Box className={classes.stepperButtons}>
      {props.show && (
        <Button
          key={props.isLastStep ? 'submit' : 'next'}
          type={props.isLastStep ? 'submit' : 'button'}
          sx={{textTransform: 'none'}}
          disabled={disabledButton}
          onClick={props.isLastStep ? undefined : props.onPressCallback}>
          <PrimaryButton
            className={disabledButton ? classes.buttonDisabled : classes.button}
            bgcolor={primaryColor}
            color={secondaryTextColor}>
            <Typography variant="body1">{localizedDynamic('SaveAndContinue')}</Typography>
          </PrimaryButton>
        </Button>
      )}
    </Box>
  );
});
